module.exports = __webpack_public_path__ + "img/client-cvc-brasil.7a2a2c68.jpg";